/**
 * Internal dependencies
 */
import SERVICE_ACTION from '@naruto/bgdapp/src/reducers/cores/service/events';
import {
  SetServiceContentInitialAction,
  SetServiceListAction,
  SetServiceInfoAction,
  ServiceList,
  ServiceListCondition,
  ServiceInfo
} from './types';

/* Initial */
export const SET_SERVICE_INITIALIZE = (): SetServiceContentInitialAction => ({
  type: SERVICE_ACTION.SET_SERVICE_INITIALIZE
});

/* Service Action */
export const SET_SERVICE_LIST = ({
  list,
  condition
}: {
  list: ServiceList;
  condition: ServiceListCondition;
}): SetServiceListAction => ({
  type: SERVICE_ACTION.SET_SERVICE_LIST,
  list,
  condition
});
export const SET_SERVICE_INFO = ({
  serviceID,
  serviceInfo
}: {
  serviceID: string;
  serviceInfo: ServiceInfo;
}): SetServiceInfoAction => ({
  type: SERVICE_ACTION.SET_SERVICE_INFO,
  serviceID,
  serviceInfo
});
